import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";


export const forgotPasswordSendOtp = createAsyncThunk(
    "/forgotPassword/sendOtp",
    async (reqBody: any) => {
        try {
            const url = API_ENDPOINTS.forgotPasswordSendOtp;
            const { axiosPost } = useCustomAxios();
            const response = await axiosPost(url, reqBody);
            return {
                data: response.data,
                status: response.status,
            }
        }
        catch (error: any) {
            return {
                error: error.response.data.message,
                statusCode: error.response.status,
            };
        }
    }
)

export const forgotPasswordVerifyOtp = createAsyncThunk(
    "/forgotPassword/verifyOtp",
    async (reqBody: any) => {
        try {
            const url = API_ENDPOINTS.forgotPasswordVerifyOtp;
            const { axiosPost } = useCustomAxios();
            const response = await axiosPost(url, reqBody);
            return {
                data: response.data,
                status: response.status,
            }
        }
        catch (error: any) {
            return {
                error: error.response.data.message,
                statusCode: error.response.status,
            };
        }
    }
)

export const resetAccountPassword = createAsyncThunk(
    "/resetAccountPassword",
    async (reqBody: any) => {
        try {
            const { data, authToken } = reqBody;
            const url = API_ENDPOINTS.partyResetAccountPassword;
            const { axiosPost } = useCustomAxios();

            const config = { headers: { Authorization: `Bearer ${authToken}`, "x-source": "SOCIETYPORTAL" } }

            const response = await axiosPost(url, data, config);
            return {
                data: response.data,
                status: response.status,
            }
        }
        catch (error: any) {
            return {
                error: error.response.data.message,
                statusCode: error.response.status,
            };
        }
    }
)

